import { useEffect, useRef, useState } from "react";
import { ClockState, ClockSync, Game, GameEndMessage } from "@mancala/core";

const TICK_MS = 250;

// Both players' clocks in a live game, counting down between the server's messages. Undefined when the server sends
// no clock.
export default function useGameClock(game: Game | undefined, gameEnd: GameEndMessage | undefined): ClockState | undefined {
    const sync = useRef(new ClockSync()).current;
    const lastGame = useRef<Game>();
    // Every game message is a new object, so a changed reference means a new message.
    if (game && game !== lastGame.current) {
        sync.update(game);
        lastGame.current = game;
    }
    if (gameEnd) sync.stop(gameEnd.clock);

    const [, setTick] = useState(0);
    const isRunning = sync.isRunning;
    useEffect(() => {
        if (!isRunning) return;
        const timer = setInterval(() => setTick((tick) => tick + 1), TICK_MS);
        return () => clearInterval(timer);
    }, [isRunning]);

    return sync.getTimes();
}
